import axios, { AxiosError } from 'axios'

export const isCanceledError = (error: unknown): error is AxiosError => {
  return axios.isCancel(error)
}